<template>
    <div>
        <div class="dc-tab-row">
            <div class="dc-tab"
                :class="[{'active': activeTab == 'detail'}]"
                @click="clickChangeTab('detail')">
                <div class="dc-inner-btn">{{lbl.detail.detail}}</div>
            </div>
            <div class="dc-tab"
                :class="[{'active': activeTab == 'condition'}]"
                @click="clickChangeTab('condition')">
                <div class="dc-inner-btn">{{lbl.detail.condition}}</div>
            </div>
        </div>
        <div class="dc-line"></div>
        <div class="dc-content">
            <div class="dc-content-item"
                v-show="activeTab === 'detail'"
                v-html="detail"></div>
            <div class="dc-content-item"
                v-show="activeTab === 'condition'"
                v-html="condition"></div>
        </div>
  </div>
</template>
<script>
import Util from '@/helper/Utility.js';

/**
 * @event clickChangeTab
 */
export default {
    name: "CampaignDetailAndCondtition",
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function() {
        return {
            activeTab: "detail", //detail, condition
            detail: "",
            condition: ""
        };
    },
    created: function() {
        this.detail = Util.newLineToBr(this.campaign.detail);
        this.condition = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        //event
        clickChangeTab: function(tab) {
            this.activeTab = tab;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
.dc-tab-row {
    @extend %display-flex;
    width: 50%;
    .dc-tab {
        width: 50%;
        flex: 0 0 50%;
        padding: 10px 0;
        //font
        font-size: $px16;
        color: $a-black-333333;
        text-align: center;
        line-height: 1;

        &.active {
            color: $a-orange-f8a51b;
            border-bottom: 1px solid $a-orange-f8a51b;
        }
    }
}

.dc-line {
    width: 100%;
    border-bottom: 1px solid $a-gray-e5e5e5;
}

.dc-content {
    width: 100%;
    padding: 25px 15px 40px;

    .dc-content-item {
        word-break: break-word;
        line-height: 1.5;
        font-size: $px16;
        color: $a-black-333333;

        a {
            color: #d31145;
        }
    }
}
</style>
